import React, { useContext } from 'react'
import { Snackbar, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { SnackBarContext } from '../context/common'
import { useSelector } from 'react-redux'
import { selectLocale } from '../redux/locale/selectors'

const AUTO_HIDE_DURATION = 5000

export default function SimpleSnackbar () {
  const locale = useSelector(selectLocale)
  const { id, feedback, keepOpen } = useContext(SnackBarContext)
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    setOpen(true)
  }, [id, feedback])

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  if (!feedback) return null

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={open}
        slotProps={{
          root: {
            style: {
              height: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word'
            }
          }
        }}
        autoHideDuration={keepOpen ? undefined : AUTO_HIDE_DURATION}
        onClose={handleClose}
        key={id}
        message={feedback}
        action={(
          <>
            <IconButton
              size='small'
              aria-label={locale.close}
              color='inherit'
              onClick={handleClose}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          </>
        )}
      />
    </div>
  )
}
